import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import { defaultFilters } from "@dealer-center/ddc-pages-account-search-interface";
import type { UseLocalStorageReducerDispatch } from "@dealer-center/core-components";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CheckmarkSolidIcon,
  XMarkIcon,
  useLocalStorageReducerActions
} from "@dealer-center/core-components";
import { PagesClientSearchSearchPillsArea } from "../Bottom/Tabs/Results/SearchPills";
import styled from "styled-components";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";
import { useContext } from "react";

const StyledSaveFiltersButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  svg {
    margin-right: 5px;
  }
`;
const StyledCard = styled(Card)`
  .panel-title {
    width: 100%;
  }
`;
const StyledCardHeader = styled(CardHeader)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  p {
    flex-grow: 1;
  }
`;
const StyledCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const StyledClearFiltersButton = styled(Button)`
  display: flex;
  align-items: center;
  padding: 0;
  svg {
    margin-right: 5px;
  }
`;
const StyledButtonArea = styled.div`
  margin-bottom: 1rem;
`;

const StyledArea = styled.div`
  display: block;
`;
interface FiltersChipCardProps {
  dispatchAccountSearchFavorites: UseLocalStorageReducerDispatch<dealerSearchIncoming>;
}
export const FiltersChipCard = ({
  dispatchAccountSearchFavorites
}: FiltersChipCardProps) => {
  const { searchRequest, isSearchDefault, updateSearchRequest } =
    useContext(AccountSearchContext);

  if (isSearchDefault) return null;
  return (
    <StyledCard
      content={
        <CardContent>
          <StyledArea>
            <div>
              <PagesClientSearchSearchPillsArea />
            </div>
            <div>
              <StyledButtonArea>
                <StyledSaveFiltersButton
                  analyticsConfiguration={{
                    eventName: "Save Filters"
                  }}
                  buttonStyle="secondary"
                  disabled={isSearchDefault}
                  onClick={() =>
                    dispatchAccountSearchFavorites({
                      action: useLocalStorageReducerActions.add,
                      payload: searchRequest
                    })
                  }
                >
                  <StyledCenter>
                    <CheckmarkSolidIcon title="Save Filters" />
                    Save Filters
                  </StyledCenter>
                </StyledSaveFiltersButton>
              </StyledButtonArea>
            </div>
          </StyledArea>
        </CardContent>
      }
      header={
        <StyledCardHeader>
          <p>Selected Filters</p>
          <StyledClearFiltersButton
            analyticsConfiguration={{
              eventName: "Clear Filters"
            }}
            buttonStyle="aux"
            disabled={isSearchDefault}
            size="small"
            onClick={() => updateSearchRequest(defaultFilters)}
          >
            <XMarkIcon title="Clear Filters" />
            CLEAR FILTERS
          </StyledClearFiltersButton>
        </StyledCardHeader>
      }
    />
  );
};
